import logo from '@img/Compozz_logo_blanc_sans_baseline.svg';
import '@app/App.css';
import { TW_AppHeader, TW_Logo } from '@utils/twClasses';
import AppHeaderNav from './header/AppHeaderNav';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from 'src/store';
import { DEFAULT_COMPOZZ_COLOR } from '@utils/colors';

function HomeHeader() {
  const navigate = useNavigate();
  const tenant = useAppStore(state => state.tenant);

  var color = tenant?.customColor ?? DEFAULT_COMPOZZ_COLOR;
  
  return (
    <header className={TW_AppHeader} style={{ backgroundColor: color }}>
      <img src={logo} className={TW_Logo + " cursor-pointer"} alt="logo" height="40px" width="auto" onClick={() => navigate('/')}/>
      <div className='grow' />
      <AppHeaderNav />
    </header>
  );
};

export default HomeHeader;